export enum CourseType {
    VIDEO = 'video',
    ARTICLE = 'article'
}
